import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMailbox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMailbox"><Path d="M12.5 22V9.5C12.5 6.73858 10.2614 4.5 7.5 4.5H7" stroke="currentColor"/><Path d="M16.5 4.5H7.5C4.73858 4.5 2.5 6.73858 2.5 9.5V19.5H21.5V9.5C21.5 6.73858 19.2614 4.5 16.5 4.5Z" stroke="currentColor"/><Path d="M5 9.5H10" stroke="currentColor"/></CentralIconBase>;
});

export default IconMailbox;
